import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  children: ReactNode;
  className?: string;
  inputId: string;
  label?: IntlKey;
  labelText?: string;
}

export function FormGroup({ inputId, label, labelText, children, className }: Props) {
  const { formatMessage } = useIntl();
  const finalLabelText = labelText ?? (label !== undefined ? formatMessage({ id: label }) : '');

  return (
    <div className={classNames('form-group', className)} data-e2e={inputId}>
      <label htmlFor={inputId} className="col-form-label">
        {finalLabelText}
      </label>
      {children}
    </div>
  );
}
